/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CpdsSectionTitleStyleTag, SectionEyebrowP, SectionTitleDescriptionP, SectionTitleDiv, SectionTitleP, SectionTitleH2 } from './styles/cpds-section-title-style';
import { CpdsSectionTitleProps } from './typings';
import { themeStyleClass, themeToken } from '../utils/cpds-utils';
import {extractText} from "../../helper";
// textAlign="left" textColor='#676A7D' fontSize='18px' lineHeight="32px" fontWeight={700}
const CpdsSectionTitle: React.FC<CpdsSectionTitleProps> = (props) => { 
  const { domRef, 
    exClasses, 
    styleOverrides, 
    children, 
    eyebrowStyles :{textAlign:eTextAlign,fontSize:eFontSize,fontWeight:eFontWeight,lineHeight:eLineHeight,textColor:eTextColor, themeTypography:eThemeTypography, exClasses:exClassesEyebrowP},
    titleStyles :{textAlign:tTextAlign,fontSize:tFontSize,fontWeight:tFontWeight,lineHeight:tLineHeight,textColor:tTextColor, themeTypography:tThemeTypography, exClasses:exClassesTitleP},
    descriptionStyles :{textAlign:dTextAlign,fontSize:dFontSize,fontWeight:dFontWeight,lineHeight:dLineHeight,textColor:dTextColor, themeTypography:dThemeTypography, exClasses:exClassesDescriptionP},
    titleData:{eyebrow,title,description},
    bgColor,
    themeColorMode,
    themeTypography
  } = props;

  const classNameSectionTitleStyleTag = themeStyleClass('cpds-section-title', themeTypography, exClasses);
  const classNameSectionEyebrowP = themeStyleClass('cpds-section-eyebrow-p', eThemeTypography, exClassesEyebrowP);
  const classNameSectionTitleP = themeStyleClass('cpds-section-title-p', tThemeTypography, exClassesTitleP);
  const classNameSectionDescriptionP = themeStyleClass('cpds-section-description-p', dThemeTypography, exClassesDescriptionP);
  const generatedId = extractText(title);
  /* Important : By default html tag is <div></div> 
  but you can change that into suitable html element base on your requirements*/
  // { eyebrow && <SectionTitleDiv><SectionEyebrowP textAlign={eTextAlign} textColor={eTextColor} fontSize={eFontSize} lineHeight={eLineHeight} fontWeight={eFontWeight} themeColorMode={themeColorMode}>{eyebrow}</SectionEyebrowP></SectionTitleDiv>}
  return (
    <CpdsSectionTitleStyleTag className={classNameSectionTitleStyleTag} ref={domRef} styleOverrides={styleOverrides} themeColorMode={themeColorMode} bgColor={bgColor}>
      {eyebrow && <SectionTitleDiv><SectionEyebrowP className={classNameSectionEyebrowP} textAlign={eTextAlign} textColor={eTextColor} themeColorMode={themeColorMode}>{eyebrow}</SectionEyebrowP></SectionTitleDiv>}
      {title && <SectionTitleDiv><SectionTitleH2 id={generatedId && generatedId !== '' ? generatedId : undefined} className={classNameSectionTitleP} textAlign={tTextAlign} textColor={tTextColor} fontSize={tFontSize} lineHeight={tLineHeight} fontWeight={tFontWeight} themeColorMode={themeColorMode}>{title}</SectionTitleH2></SectionTitleDiv>}
      {description && <SectionTitleDiv><SectionTitleDescriptionP className={classNameSectionDescriptionP} textAlign={dTextAlign} textColor={dTextColor} fontSize={dFontSize} lineHeight={dLineHeight} fontWeight={dFontWeight} themeColorMode={themeColorMode}>{description}</SectionTitleDescriptionP></SectionTitleDiv>}
    </CpdsSectionTitleStyleTag>
  );
};

export default CpdsSectionTitle;

